import getCropFormat from './getCropFormat';
import isT1Image from './isT1Image';

// The PDP hero is rendered on the server, where JBProductImage cannot run. Both
// must build the same imgix URL, or the hero jumps after hydration (CON-8543).
//
// Only the base params live here. JBProductImage adds the fullscreen gallery
// cases on top.
const getProductImageBaseImgixParams = ({
  type,
  src,
  crops,
  enableCrops,
  isMobileOrTablet = false,
}) => {
  if (!enableCrops) {
    return {};
  }

  const isConfiguration = type === 'configuration' || type === 'cylindo';
  const isStudio = type === 'studio';

  if (!isConfiguration && !isStudio) {
    return {};
  }

  const cropFormat = getCropFormat({ enableCrops, isMobileOrTablet });
  if (cropFormat && crops?.[cropFormat]) {
    // Manual crop data wins; convertImgixPropsToQueryParams applies it directly.
    return {};
  }

  let params = {
    ar: isMobileOrTablet ? '1:1' : '3:2',
    crop: 'center',
    trim: 'color',
    trimColor: 'F5F6F8',
    trimTol: 50,
    trimPad: 50,
    fit: 'fill',
    fill: 'solid',
    fillColor: 'F5F6F8',
  };

  if (isStudio && isT1Image(src)) {
    params = { ...params, trimPad: 180 };
  }

  if (isConfiguration) {
    params = {
      ...params,
      fit: isMobileOrTablet ? 'max' : 'fill',
      crop: 'entropy',
      fillColor: 'fff',
      trimColor: 'none',
      pad: isMobileOrTablet ? 20 : 40,
    };
  }

  return params;
};

export default getProductImageBaseImgixParams;
